import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['content', 'trigger', 'dialog', 'input', 'populateValue', 'focus']
  
  toggle(event) {
    event.preventDefault();
    this._isHidden() ? this.show(event) : this.hide(event)
  }
  
  show(event) {
    event.preventDefault();
    this.contentTarget.classList.remove('hide')
  }
  
  hide(event) {
    this.contentTarget.classList.add('hide')
  }
  
  clickAway(event) {
    event.target.contains(this.contentTarget) ? this.hide(event) : false
  }
  
  clearFormFields() {
    const inputs = this.contentTarget.querySelectorAll('input[type=text]')
    for (const input of inputs) {
      input.value = ''
    }
  }
  
  populateField() {
    this.inputTarget.value = this.populateValueTarget.value
    this.inputTarget.focus()
  }
  
  giveFocus() {
    if (this.hasFocusTarget) {
      this.focusTarget.focus()
    }
  }
  
  // private
  
    _isHidden() {
      return this.contentTarget.classList.contains('hide')
    }
}